// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-content > .tab-pane[data-v-05f15de2] {\n  display: block;\n  top: 0;\n}\n.tab-content[data-v-05f15de2] {\n  overflow-y: hidden;\n  position: relative;\n  transition: all 0.4 linear !important;\n  box-sizing: content-box;\n}\n.dropdown[data-v-05f15de2] {\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
